import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useQuery } from "@tanstack/react-query";
import { optionsWithDefaults } from "../_helpers/options-with-defaults";
import { Options } from "../_types";

const API_RESOURCE = "user" as const;
const API_OPERATION = "supervisor" as const;
// eslint-disable-next-line typescript/no-unused-vars
const API_PATH = `/v1/${API_RESOURCE}/{uuid}/${API_OPERATION}` as const;

export type UserSupervisorParameters = paths[typeof API_PATH]["get"]["parameters"]["query"];
export type UserSupervisorResponse = paths[typeof API_PATH]["get"]["responses"][200]["content"]["application/json"];

export function useUserSupervisorQuery(uuid: string, options?: Options<UserSupervisorParameters, never>) {
  const optionsWithDefaultsResolved = optionsWithDefaults<Options<UserSupervisorParameters, never>>(options);

  const requestParameters = {
    ...(optionsWithDefaultsResolved.parameters || {}),
  };

  return useQuery({
    queryKey: [API_RESOURCE, uuid, API_OPERATION, { parameters: requestParameters }],
    queryFn: async () => {
      const response = await alphartisApiAxios.get<UserSupervisorResponse>(
        `/v1/${API_RESOURCE}/${uuid}/${API_OPERATION}`,
        {
          params: requestParameters,
        },
      );

      return response.data;
    },
  });
}
